import { useUserProductsAndTenorsContext } from '@shared/contexts/UserProductsAndTenorsProvider';
import { useMemo } from 'react';

export function useUserProductBySymbol(symbol: string) {
  const { userProducts, loaded } = useUserProductsAndTenorsContext();

  const product = useMemo(() => {
    if (!loaded || !symbol) return undefined;
    return userProducts.find(p => p.symbol === symbol);
  }, [userProducts, loaded, symbol]);

  const hasAccess = useMemo(() => {
    return loaded && !!product;
  }, [loaded, product]);

  return {
    product,
    hasAccess,
    loaded,
  };
}
